import React, { Component } from 'react'
import dateFns from 'date-fns'
import classNames from 'classnames'
import { centsToDollars } from '../utils'

import { Text } from 'components/base'

export default class InvoicesList extends Component {
  render() {
    return (
      <table
        className={this.props.className}
        style={{ borderCollapse: 'collapse' }}
      >
        <thead>
          <tr
            className="uppercase shade-20 font-weight-bold font-size-small"
            style={{ height: 50 }}
          >
            <td className="padding-left-normal">ID</td>
            <td>Date</td>
            <td>Amount</td>
            <td>Status</td>
            <td align="right" className="padding-right-normal">
              PDF
            </td>
          </tr>
        </thead>
        <tbody>
          {this.props.invoices.map(invoice => {
            return (
              <tr
                key={invoice.id}
                className="background-shade-100 background-shade-50-on-hover"
                style={{ height: 50 }}
              >
                <td className="padding-left-normal">{invoice.number}</td>
                <td>{dateFns.format(invoice.date, 'MMM DD, YYYY')}</td>
                <td>{centsToDollars(invoice.amount)}</td>
                <td>
                  <span
                    className={classNames(
                      'uppercase border-small radius-normal font-weight-bold font-size-small padding-vertical-smaller padding-horizontal-small',
                      {
                        green: invoice.status === 'paid',
                        red: invoice.status === 'due',
                        teal: invoice.status === 'draft',
                      }
                    )}
                  >
                    {invoice.status}
                  </span>
                </td>
                <td align="right" className="padding-right-normal">
                  {invoice.pdfUrl ? (
                    <Text.ExternalLink href={invoice.pdfUrl}>
                      Invoice
                    </Text.ExternalLink>
                  ) : (
                    'Not available yet'
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }
}
